import { buildURL } from "react-imgix";

import { getPathFromModel } from './link';

const createSchema = () => {
	return {
		'@context': 'http://schema.org',
	}
}

const appendImage = (obj, image) => {
	if (image) {
		obj['image'] = [
			buildURL(image.url, { w: 1200, h: 1200 }),
			buildURL(image.url, { w: 1200, h: 900 }),
			buildURL(image.url, { w: 1200, h: 675 }),
		]
	}
}

const appendPublisherLogo = (obj, siteURL) => {
	if (siteURL) {
		obj["logo"] = {
			"@type": "ImageObject",
			"width": "600",
			"height": "60",
			"url": `${siteURL}/images/publisher-logo.png`
		}
	}
}

const appendPublisher = (obj, siteName, siteURL) => {
	if (siteName) {
		obj['publisher'] = {
			'@type': 'Organization',
			name: siteName
		}

		appendPublisherLogo(obj['publisher'], siteURL);
	}
}

const appendModified = (obj, pageModified) => {
	if (pageModified) {
		obj['dateModified'] = pageModified;
	}
}

const appendCreated = (obj, pageCreated) => {
	if (pageCreated) {
		obj['datePublished'] = pageCreated;
	}
}

const appendAuthor = (obj, author) => {
	if (author && author.name) {
		obj['author'] = {
			'@type': author.name === "Auriens" ? "Organization" : "Person",
			name: author.name,
		}
	}
}

const appendHeadline = (obj, headline) => {
	if (headline) {
		obj['headline'] = headline;
	}
}

const appendURL = (obj, siteUrl, pagePath) => {
	if (siteUrl && pagePath) {
		obj['url'] = siteUrl + pagePath;
	}
}

const appendName = (obj, pageTitle) => {
	if (pageTitle) {
		obj['name'] = pageTitle;
	}
}

const appendDescription = (obj, pageDescription) => {
	if (pageDescription) {
		obj['description'] = pageDescription;
	}
}

const appendMainEntity = (obj, siteUrl, pagePath) => {
	if (siteUrl && pagePath) {
		obj['mainEntityOfPage'] = siteUrl + pagePath;
	}
}

const appendLanguage = (obj, languageCode) => {
	if (languageCode) {
		obj['inLanguage'] = {
			"@type": "Language",
			"name": languageCode,
			// "alternateName": languageCode
		}
	}
}

const appendType = (obj, type) => {
	if (type) {
		obj['@type'] = type;
	}
}

export const getSchema = (props) => pageSchema(props);

export const pageSchema = ({
	settings,
	site,
	page
}) => {

	if (page.model.apiKey === "article") {
		let schema = createSchema();
		appendType(schema, "Article");
		appendLanguage(schema, page.locale || "en");
		appendURL(schema, settings.siteUrl, getPathFromModel({ model: page.model, slug: page.slug }));
		appendImage(schema, page.banner);
		appendHeadline(schema, page.title);
		appendCreated(schema, page.meta.firstPublishedAt);
		appendModified(schema, page.meta.publishedAt);
		appendAuthor(schema, page.author);
		return schema;
	}
	else if (page.seo && page.seo) {
		let schema = createSchema();
		appendType(schema, "WebPage");
		appendLanguage(schema, page.locale || "en");
		appendURL(schema, settings.siteUrl, getPathFromModel({ model: page.model, slug: page.slug }));
		appendName(schema, page.seo.title);
		appendDescription(schema, page.seo.description);
		appendCreated(schema, page.meta.firstPublishedAt);
		appendModified(schema, page.meta.publishedAt);

		return schema;
	}

	return null;
}